module.exports = () => {
  window.onUsersnapCXLoad = function(api) {
    api.init();
  }
  var script = document.createElement('script');
  script.defer = 1;
  script.src = 'https://widget.usersnap.com/global/load/3ec88a98-0154-439d-aee5-88eee5228fac?onload=onUsersnapCXLoad';
  document.getElementsByTagName('head')[0].appendChild(script);
}